export const globalInvoiceTypes = {
  GET_GLOBAL_INVOICE_PAYMENTS_TYPES: "GET_GLOBAL_INVOICE_PAYMENTS_TYPES",
  GET_GLOBAL_INVOICE_LICENSES: "GET_GLOBAL_INVOICE_LICENSES",
  GET_GLOBAL_INVOICE: "GET_GLOBAL_INVOICE",
  SET_GLOBAL_INVOICE_FILTERS: "SET_GLOBAL_INVOICE_FILTERS",
  CREATE_GLOBAL_INVOICE_BREAKDOWN: "CREATE_GLOBAL_INVOICE_BREAKDOWN",
  SET_GLOBAL_INVOICE_UNIT_PRICES: "SET_GLOBAL_INVOICE_UNIT_PRICES",
  SET_GLOBAL_INVOICE_QUANTITY: "SET_GLOBAL_INVOICE_QUANTITY",
  RESTORE_INITIAL: "RESTORE_INITIAL",
};
